<template>
  <!-- A red edge vignette that pulses like a heartbeat when the shared pool is down to its last
       heart, so the core stake of the game (running dry = run over) actually feels tense rather
       than looking the same at 1 heart as at 8. Pointer-events none: purely ambient.
       Teleported to <body> so position:fixed anchors to the real viewport (a transformed/filtered
       ancestor inside the game tree would otherwise clip the top/bottom edges on iOS). -->
  <Teleport to="body">
    <Transition name="danger-fade">
      <div v-if="active" class="danger-aura" aria-hidden="true"></div>
    </Transition>
  </Teleport>
</template>

<script setup>
defineProps({
  active: {type: Boolean, default: false},
});
</script>

<style scoped>
.danger-aura {
  position: fixed;
  inset: 0;
  pointer-events: none;
  /* Below the momentum aura (z-30) so a rare simultaneous hot streak still reads over it. */
  z-index: 25;
  animation: danger-pulse 1.3s ease-in-out infinite;
}

/* A double-thump heartbeat: a quick lub-dub each cycle rather than an even sine pulse. */
@keyframes danger-pulse {
  0%, 100% {
    box-shadow: inset 0 0 50px 8px rgba(220, 38, 38, 0.22);
  }
  18% {
    box-shadow: inset 0 0 95px 22px rgba(220, 38, 38, 0.42);
  }
  34% {
    box-shadow: inset 0 0 60px 12px rgba(220, 38, 38, 0.26);
  }
  50% {
    box-shadow: inset 0 0 88px 20px rgba(220, 38, 38, 0.38);
  }
}

.danger-fade-enter-active,
.danger-fade-leave-active {
  transition: opacity 0.4s ease;
}

.danger-fade-enter-from,
.danger-fade-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .danger-aura {
    animation: none;
    box-shadow: inset 0 0 70px 14px rgba(220, 38, 38, 0.3);
  }
}
</style>
